import type { FaqAdminContent } from '../../content/sections/faq-admin.js';
import { ApiError } from '../../lib/http.js';

/* Mensagem para o CRUD de FAQ (ADR-0658/0697). O `faqError` (faq-api.ts) preserva o código do
   backend em `ApiError.message` e o HTTP status em `ApiError.status`; este mapper decide a
   mensagem por status (auth/conflito) e reconhece o conflito de slug pela mensagem — em vez do
   onError exibir sempre a mesma causa hardcoded. `copy` vem de `useFaqAdminContent().errors` no
   único call site (`faq-form-modal.tsx`), que já está dentro de render e pode chamar o hook. */
const HTTP_UNAUTHORIZED = 401;
const HTTP_FORBIDDEN = 403;
const HTTP_CONFLICT = 409;

export function faqErrorMessage(err: unknown, copy: FaqAdminContent['errors']): string {
  if (err instanceof ApiError) {
    if (err.code === 'network' || err.status === 0) {
      return copy.networkFailure;
    }
    if (err.status === HTTP_UNAUTHORIZED || err.status === HTTP_FORBIDDEN) {
      return copy.forbidden;
    }
    if (err.status === HTTP_CONFLICT || err.message.includes('slug')) {
      return copy.slugConflict;
    }
    return copy.genericFailure;
  }
  return copy.unexpected;
}
